export default {
    "empty": {},
    "languageName": 'Deutsch',
    "en": { text: 'Englisch' },
    "ro": { text: 'Rumänisch' },
    "de": { text: 'Deutsch' },
    "hr": { text: 'Kroatisch' },

    "take-a-seat": { text: 'Nimm Platz' },
    "share-your-screen": { text: 'Teile Deinen Bildschirm' },
    "open-link": { text: 'Öffne Link' },
    "change-scene": { text: 'Wechsle die Szene' },
    "make-a-donation": { text: 'Spenden' },
    "play-chess": { text: 'Spiel Schach' },
    "shop": { text: 'Shop' },

    "take-seat-custom-message": { text: 'Möchtest Du auf diesem Stuhl platznehmen?' },
    "share-location": { text: 'Teile diesen Ort' },
    "share-location-input": { placeholder: 'Raum URL' },
    "share-location-submit": { value: 'Kopiere URL' },
    "media-settings": { text: 'Einstellungen' },
    "media-settings-submit": { value: 'Einstellungen übernehmen' },

    "user-menu-status": { text: 'Status' },
    "user-mood-available": { text: 'Ansprechbar' },
    "user-mood-away": { text: 'Beschäftigt' },
    "user-mood-dnd": { text: 'Bitte nicht stören' },
    "user-edit-profile": { text: 'Profil bearbeiten' },
    "user-profile-login": { text: 'Anmeldung' },
    "user-profile-logout": { text: 'Abmelden' },
    "user-profile-edit-room": { text: 'Raum bearbeiten', value: 'Raum bearbeiten' },

    "avatar-upload-title": { text: 'Foto hochladen' },
    "avatar-crop-title": { text: 'Foto zuschneiden' },
    "avatar-upload-requirements": { text: '250x250 Min / 5 MB Max' },
    "upload-photo-button": { text: 'Foto hochladen' },
    "save-button": { text: 'Speichern' },
    "cancel-button": { text: 'Abbrechen' },
    "avatar-upload-error-size": { text: 'Die Bilddateigröße muss kleiner als 5 MB sein' },
    "avatar-upload-error-type": { text: 'Bitte wählen Sie eine gültige Bilddatei (JPEG, PNG, GIF)' },
    "avatar-upload-error-dimensions": { text: 'Das Bild muss mindestens 250x250 Pixel groß sein' },
    "avatar-upload-error-upload": { text: 'Upload fehlgeschlagen. Bitte versuchen Sie es erneut.' },
    "avatar-upload-error-process": { text: 'Bild konnte nicht verarbeitet werden. Bitte versuchen Sie es erneut.' },

    "tune-menu-device-settings": { text: 'Geräteeinstellungen' },
    "tune-menu-elements-visible": { text: 'Interaktionen Sichtbar' },
    "tune-menu-ambient-music": { text: 'Hintergrund Sound' },
    "tune-menu-compass": { text: 'Kompass' },
    "device-orientation-controller": { text: 'Gyro Steuerung' },
    "tune-menu-welcome-screen": { text: 'Wilkommensdialog' },
    "tune-menu-exit-room": { text: 'Raum verlassen' },
    "tune-menu-lock-location": { text: 'Lokaler Raum' },
    "tune-menu-help": { text: 'Hilfe' },

    "leave-preview-text": { text: 'Vorschau verlassen' },
    "close-text": { text: 'Schließen' },
    "download-text": { text: 'Herunterladen' },
    "content-text": { text: 'Inhalt' },
    "date-text": { text: 'Datum' },
    "vrai-agent-talk-summary-title": { text: 'Gesprächszusammenfassung' },
    "room-chat-header-text": { text: 'Raum-Chat' },
    "people-text": { text: 'Leute' },
    "scene-text-chat": { text: 'In diesem Raum' },
    "room-text": { text: 'Gesamter Raum' },
    "friends-text": { text: 'Freunde' },
    "tour-text": { text: "Tour" },
    "podium-text": { text: 'Tour-Podium' },
    "invite-to-tour-text": { text: "Zur Tour einladen" },
    "invite-to-podium-text": { text: "Tour Gäste" },
    "invite-to-podium-text-user": { text: "Lade {user} zum Podium ein" },
    "invite-as-tour-guest-text": { text: "Als Tour-Gast einladen" },
    "invite-to-podium-menu-text": { text: "Zum Podium einladen" },
    "remove-from-podium-text": { text: "Vom Podium entfernen" },
    "remove-from-tour-text": { text: "Aus der Tour entfernen" },
    "podium-invitation-sent-text": { text: "Podium-Einladung gesendet" },
    "is-inviting-you-to-podium": { text: "{user} lädt dich zum Podium der Tour {name} ein" },
    "pending-invitation-text": { text: "Nicht in Tour" },
    "waiting-for-response-text": { text: "(Warten auf Antwort)" },
    "jump-to-scene-text": { text: 'Springe zur Szene' },
    "invite-to-scene-text": { text: 'Lade ein in Deine Szene' },
    "add-as-friend-text": { text: 'Als Freund hinzufügen' },
    "show-user-info-text": { text: 'Benutzerinfo anzeigen' },
    "remove-from-friends-text": { text: 'Von Freunden entfernen' },
    "invite-tour-user-info-text": { text: 'Zur Tour einladen' },
    "invite-tour-user-as-guest": { text: 'Gäste einladen' },
    "you-text": { text: 'Du' },
    "chat-text": { text: 'Chat' },
    "type-msg-placeholder": { placeholder: 'Nachricht eigeben' },
    "send-text": { text: 'Abschicken' },
    "invite-to-scene-title": { text: 'Einladung zur Szene' },
    "invitation-message": { text: 'lädt Dich zur Szene ein.' },
    "join-scene-text": { text: 'Gehe zu' },
    "invitation-message-tour": { text: 'Zur Tour einladen' },
    "yes-text": { text: 'Ja' },
    "cancel-text": { text: 'Abbruch', value: 'Abbruch' },
    "delete-text": { text: 'Löschen' },
    "save-text": { text: 'Sichern' },
    "save-value": { value: 'Speichern' },
    "access-room-text": { text: 'Raum betreten' },
    "microphone-text": { text: 'Mikrofon' },
    "camera-text": { text: 'Kamera' },
    "sound-text": { text: 'Ton' },
    "join-room-text": { text: 'Betrete den Raum' },
    "take-seat-text": { text: 'Nimm Platz' },
    "take-seat-value": { value: 'Nimm Platz' },
    "preview-text": { text: 'Vorschau' },
    "publish-text": { text: 'Veröffentlichen' },
    "view-mode-title": { title: 'In den Besuchermodus wechseln' },
    "nav-view-mode": { title: 'In den Besuchermodus wechseln', text: 'Zum Besuchermodus' },
    "exit-text": { text: 'Ausgang' },
    "join-as-guest-text": { text: 'ALs Gast betreten' },
    "edit-profile-guest-notice": { text: 'Als Gast hast Du nur eingeschränkte Möglichkeiten und Funktionen' },
    "edit-profile-text": { text: 'Profil bearbeiten' },
    "my-profile-text": { text: 'Mein Profil' },
    "spaces-text": { text: 'Räume' },
    "tours-text": { text: 'Touren' },
    "notifications-text": { text: 'Benachrichtigungen' },
    "subscription-billing-text": { text: 'Abonnement & Abrechnung' },
    "username-text": { text: 'Benutzername' },
    "avatar-image-text": { text: 'Profil Bild' },
    "avatar-image-alt": { alt: 'Profil Bild' },
    "image-alt": { alt: 'Profil Bild' },
    "upload-avatar-text": { text: 'Bild hochladen' },
    "no-account-q-text": { text: "Noch nicht registriert?" },
    "login-text": { text: "Login" },
    "register-text": { text: "Registrieren" },
    "interests-text": { text: "Interessen" },
    "video-call-text": { text: "Video Anruf" },
    "send-msg-text": { text: "Nachricht schicken" },
    "see-profile-text": { text: "Profil anschauen" },
    "dont-show-again-text": { text: "Nicht noch mal zeigen" },
    "stop-screen-share-text": { text: "Bildübertragung anhalten" },
    "grid-view-text": { text: "Rasteransicht" },
    "tour-mode-text": { text: "Tour-Modus" },
    "fullscreen-text": { text: "Vollbild" },
    "page-mute-text": { text: "Seitenton stummschalten" },
    "page-unmute-text": { text: "Seitenton aktivieren" },
    "mute-text": { text: "Ton aus" },
    "unmute-text": { text: "Ton an" },
    "turn-mic-on-text": { text: "Mikrofon an" },
    "turn-mic-off-text": { text: "Mikrofon aus" },
    "has-muted-you": { text: "hat dich stummgeschaltet." },
    "has-unmuted-you": { text: "hat dein Mikrofon eingeschaltet." },
    "turn-cam-on-text": { text: "Kamera an" },
    "turn-cam-off-text": { text: "Kamera aus" },
    "stand-up-text": { text: "Platz verlassen" },
    "confirmation-text": { text: "Bestätigen" },
    "no-reason-text": { text: "kein Grund" },
    "open-game-text": { text: "Spiel starten" },
    "game-over-text": { text: "Game over" },
    "win-game-text": { text: "Spiel gewinnen" },
    "drawn-position-text": { text: "unentschieden" },
    "scene-text": { text: "szene" },
    "scenes-text": { text: "szenen" },
    "from-text": { text: "von" },
    "this-scene": { text: "diese Szene" },
    "these-scenes": { text: "diese Szenen" },
    "element-text": { text: "Element" },
    "elements-text": { text: "Elemente" },
    "general-text": { text: "General" },
    "search-placeholder": { placeholder: "Suchen..." },
    "duplicate-text": { text: 'Duplikat' },
    "upload-scene-text": { text: 'Szene hochladen' },
    "room-name-text": { text: 'Spacenamen   ' },
    "home-url-text": { text: 'Home-URL' },
    "publicly-available-text": { text: 'Öffentlich verfügbar' },
    "welcome-screen-text": { text: 'Wilkommensbildschirm' },
    "event-welcome-closed": { text: 'Willkommen geschlossen' },
    "event-consent-declined": { text: 'Benutzer hat den Einwilligungsdialog abgelehnt' },
    "action-open-welcome": { text: 'Willkommen öffnen' },
    "action-close-welcome": { text: 'Willkommen schließen' },
    "edit-text": { text: 'Bearbeiten' },
    "room-thumbnail-text": { text: 'Space Vorschau' },
    "upload-image-text": { text: 'Bild hochladen' },
    "upload-thumbnail-img-title": { title: 'Vorschaubild hochladen' },
    "delete-thumbnail-img-title": { title: 'Vorschaubild löschen' },
    "room-logo-text": { text: 'Space Logo' },
    "upload-logo-img-title": { title: 'Logo hochladen' },
    "delete-logo-img-title": { title: 'Logo löschen' },
    "splash-image-text": { text: 'Splash-Bild' },
    "upload-splash-img-title": { title: 'Splash-Bild hochladen' },
    "delete-splash-img-title": { title: 'Splash-Bild löschen' },
    "room-desc-text": { text: 'Space Beschreibung' },
    "description-placeholder": { placeholder: 'Beschreibung' },
    "room-coord-text": { text: 'Space Koordinaten' },
    "set-text": { text: 'Speichern' },
    "room-contributors-text": { text: 'Raum Autoren' },
    "scene-name-text": { text: 'Szenen Name' },
    "home-scene-text": { text: 'Start Szene' },
    "set-home-text": { text: 'Als Start setzen' },
    "set-as-home-scene-text": { text: 'Dies ist die Start Szene.' },
    "lockable-text": { text: 'Abschließbar' },
    "allow-lock-scene-text": { text: 'Benutzer können die Szene abschließen.' },
    "public-stage-text": { text: 'Öffentliche Szene' },
    "public-stage-tooltip": { text: 'Jeder Besucher kann die Sitzenden sehen und hören.' },
    "upload-text": { text: 'Hochladen' },
    "ambient-audio-volume-text": { text: 'Hintergrundaudio Lautstärke' },
    "scene-image-text": { text: 'Szenen Hintergund' },
    "upload-scene-image-title": { title: 'Szenen Hintergrund hochladen' },
    "select-text": { text: 'Auswählen' },
    "update-text": { text: 'Speichern' },
    "set-entry-point-tooltip": { text: "Setze den Eingangspunkt auf die aktuelle Richtunbg." },
    "drag-scene-title": { title: "Ziehe die Szene an eine andere Position" },
    "edit-scene-name-title": { title: "Zum Bearbeiten klicken" },
    "go-to-scene-text": { text: 'Gehe zur Szene' },
    "size-text": { text: "Größe" },
    "rotateX-text": { text: "Drehung X" },
    "rotateY-text": { text: "Drehung Y" },
    "tooltip-text": { text: "Kurzinfo" },
    "hide-on-start-text": { text: "Beim Start ausblenden" },
    "show-drag-corners-text": { text: "Zieh-Ecken anzeigen" },
    "component-name-text": { text: "Name" },
    "info-settings-text": { text: "Einstellungen" },
    "product-list-text": { text: "Produkt Liste" },
    "is-calling-you-text": { text: "ruft Dich an" },
    "requests-to-share-screen-text": { text: "möchte den Bildschirm teilen" },
    "publish-leave-text": { text: "Speichern & Gehen" },
    "discard-leave-text": { text: "Verwerfen & Gehen" },

    "confirm-take-seat": { text: 'Möchtest Du hier Platz nehmen?' },
    "confirm-title-leave-seat": { "text": "Sitz verlassen" },
    "confirm-leave-seat": { "text": "Möchten Sie Ihren Sitzplatz verlassen?" },
    "confirm-leave-game": { text: 'Möchtest DU das Spiel beenden?' },
    "confirm-locked-by": { text: 'Diese Szene wurde abgeschlossen von ' },
    "confirm-want-to-knock": { text: 'Möchtest Du anklopfen?' },
    "confirm-leaving-without-publishing": { text: "Du verlässt den Editor und hast noch nicht gespeicherte Änderungen." },
    "confirm-remove-scene": { text: "Bist Du sicher, dass Du die Szene entfernen möchtest?" },
    "confirm-remove-element": { text: "Bist Du sicher, dass Du das Element entfernen möchtest?" },
    "confirm-remove-element-has-actions": { text: "Dieses Element hat" },
    "confirm-remove-element-will-be-deleted": { text: "die ebenfalls gelöscht werden" },
    "action-text": { text: "Aktion" },
    "action-start-call": { text: "Anruf starten" },
    "action-end-call": { text: "Anruf beenden" },
    "actions-text": { text: "Aktionen" },
    "event-text": { text: "Ereignis" },
    "events-text": { text: "Ereignisse" },
    "confirm-delete": { text: "Bist Du sicher, dass Du löschen möchtest" },
    "delete-space-confirmation-title": { text: "Bist Du sicher, dass Du diesen Raum löschen möchtest?" },
    "delete-space-confirmation-subtitle": { text: "Diese Aktion kann nicht rückgängig gemacht werden. Alle Daten in diesem Raum gehen dauerhaft verloren." },
    "confirm-you-will-delete": { text: "Bestätige, dass Du löschen wirst" },
    "confirm-duplicate": { text: "Bist Du sicher, dass Du duplizieren möchtest?" },
    "confirm-you-will-duplicate": { text: "Du wirst duplizieren" },
    "confirm-remove": { text: "Bist Du sicher, dass Du löschen möchtest?" },
    "confirm-delete-world-thumbnail": { text: "Bist Du sicher, dass Du das Vorschaubild löschen möchtest?" },
    "confirm-remove-ambient-song": { text: "Möchtest Du diesen Sound entfernen?" },
    "confirm-add-as-owner-1": { text: "Bist Du sicher, dass Du hinzufügen möchtest?" },
    "confirm-add-as-owner-2": { text: "als Eigentümer?" },
    "confirm-already-calling-you-answer": { text: "ruft Dich an. Möchtest Du antworten?" },
    "confirm-room-data-changed": { text: "Raumdaten geändert, möchtest Du neu laden?" },

    "error-language-support": { text: 'Diese Sprache wird nicht unterstützt' },
    "error-take-seat": { text: 'Jemand war schneller als Sie. Der Platz wurde bereits von' },
    "error-user-data-not-found": { text: 'Benutzerdaten nicht gefunden' },
    "error-no-wp-account": { text: "hat keinen baglessaccount" },
    "error-camera-start": { text: "Kamera konnte nicht gestartet werden - wird wahrscheinlich von einer anderen App verwendet!" },
    "error-left-the": { text: " verließ die" },
    "error-user-declined-request": { text: "Der Benutzer hat die Anfrage abgelehnt" },
    "error-please-login": { text: "Bitte melde Dich an oder registriere Dich." },
    "error-screen-occupied": { text: "Bildschirm besetzt" },
    "error-screen-share-occupied": { text: "Es läuft derzeit eine Bildschirmübertragung. Bitte warten Sie, bis sie beendet ist." },
    "error-screen-share-not-allowed": { text: "Entschuldige, Du darfst diesen Bildschirm nicht teilen." },
    "error-video-stream-not-ready": { text: "Video stream noch nicht bereit. Versuche es in ein paar Sekunden nochmal" },
    "error-calling-yourself": { text: "Du hast Dich selbst angerufen." },
    "error-call-friend-disconnected": { text: "Dein Gesprächspartner wurde getrennt" },
    "error-call-friend-offline": { text: "Dein Gesprächspartner ist offline" },
    "error-call-friend-busy": { text: "Dein Gesprächspartner ist beschäftigt" },
    "error-call-friend-in-tour": { text: "Dein Gesprächspartner ist auf Tour" },
    "error-call-already-in-progress": { text: "Du befindest dich bereits in einem Anruf und kannst momentan keinen weiteren starten" },
    "error-link-to-same-location": { text: "Du kannst keinen Link zum selben Ort erstellen" },
    "error-delete-current-scene": { text: "Du versuchst die Szene zu löschen, in der Du Dich gerade befindest. Wähle eine andere Szene aus und lösche dann diese." },
    "error-enter-scene-name": { text: "Bitte gib den Namen der Szene ein." },
    "error-paypal-url": { text: "Ungültige Paypal URL" },
    "error-chess-instances": { text: "Es ist nur eine Schachpartie pro Szene erlaubt" },
    "error-provide-title": { text: "Bitte gib einen Titel an" },
    "error-button-url": { text: "Bitte gib eine URL für die Schaltfläche an" },
    "error-button-title": { text: "Bitte gib einen Titel für die Schaltfläche an." },
    "error-turn-on-camera": { text: "Bitte schalte die Kamera ein!" },
    "error-waiting-second-player": { text: "Warten auf einen zweiten Spieler" },
    "error-action-stop-screen-share": { text: "Diese Aktion kann nur von der Person ausgeführt werden, die gerade den Bildschirm teilt." },
    "error-user-dont-exist": { text: "Benutzer existiert nicht" },
    "error-invalid-email": { text: "Ungültige e-Mail Adresse" },
    "error-iframe-url": { text: "Ungültige iFrame Adresse" },
    "error-bagless-room-access": { text: "Sie können diesen Raum nicht mit Ihrer aktuellen Kontozugriffsebene betreten!" },
    "error-max-limit-reached": { text: "Die maximale Anzahl von Elementen dieses Typs wurde erreicht" },
    "error-max-locations-reached": { text: "Die maximale Anzahl an Standorten wurde erreicht" },
    "error-take-screen": { text: 'Jemand war schneller als Du. Der Bildschirm ist bereits belegt.' },
    "error-already-sharing": { text: 'Sie teilen bereits!' },
    "error-guest-cannot-buy-tickets": { text: 'Gäste können keine Tickets kaufen, bitte melden Sie sich an!' },
    "error-both-dates": { text: 'Sowohl "von" als auch "bis" Datumseingaben müssen gesetzt sein!' },
    "error-not-available-intour-mode": { text: 'Im Tourmodus nicht verfügbar' },
    "error-not-available-while-talking-with-agent": { text: 'Nicht verfügbar, während Sie mit dem Agenten sprechen' },
    "vrai-agent-end-call-confirm": { text: 'Anruf beenden?' },
    "vrai-agent-scene-change-confirm": { text: 'Sie sprechen noch mit dem KI-Agenten. Anruf beenden und zur neuen Szene wechseln?' },
    "vrai-agent-request-media": { text: 'Kamera & Mikrofon werden angefordert...' },
    "vrai-agent-request-mic": { text: 'Mikrofon wird angefordert...' },
    "vrai-agent-connecting": { text: 'Verbindung wird hergestellt...' },
    "vrai-agent-connect-failed": { text: 'Verbindung fehlgeschlagen' },
    "vrai-agent-no-assistant": { text: 'Agent nicht konfiguriert' },
    "vrai-agent-media-failed": { text: 'Kamera/Mikrofon-Zugriff erforderlich' },
    "vrai-agent-mic-failed": { text: 'Mikrofonzugriff erforderlich' },
    "vrai-agent-status-thinking": { text: 'Denkt nach...' },
    "vrai-agent-status-talking": { text: 'Spricht...' },
    "ai-interaction-consent-title": { text: 'KI-Interaktion' },
    "ai-interaction-consent-message": { text: 'Sie sind dabei, mit einem KI-System zu interagieren. Möchten Sie fortfahren?' },
    "ai-interaction-consent-accept": { text: 'Akzeptieren' },
    "ai-interaction-consent-decline": { text: 'Ablehnen' },
    "ai-interaction-active": { text: 'KI ist aktiv' },
    "ai-interaction-connecting": { text: 'Verbindung zur KI wird hergestellt' },
    "ai-interaction-listening": { text: 'KI hört zu' },
    "ai-interaction-thinking": { text: 'KI denkt nach' },
    "ai-interaction-talking": { text: 'KI spricht' },
    "error-screen-sharing-in-progress": { text: "Jemand anderes teilt bereits seinen Bildschirm. Bitte warten Sie, bis die Bildschirmfreigabe beendet ist." },

    "chess-white": { text: "weiß" },
    "chess-black": { text: "schwarz" },
    "chess-made-a-move": { text: "hat einen Zug gemacht" },
    "chess-to": { text: "zu" },
    "chess-in-your-chessgame": { text: "in Deinem Schachspiel" },
    "chess-in-checkmate": { text: "ist schachmatt" },
    "chess-in-check": { text: "ist im Schach" },
    "no-more-moves": { text: "keine Bewegungen mehr" },
    "chess-restart-text": { text: "Neustarten" },
    "chess-flip-table-text": { text: "Tisch umdrehen" },
    "chess-history-text": { text: "Verlauf" },
    "chess-lock-game-text": { text: "Spiel sperren" },

    "success-entry-point-saved": { text: "Szenen-Einstiegspunkt gespeichert!" },
    "success-added-as-owner": { text: "Benutzer als Eigentümer hinzugefügt" },
    "success-email-copied": { text: "E-Mail-Adresse in die Zwischenablage kopiert!" },
    "success-world-name-copied": { text: "Weltname in die Zwischenablage kopiert" },

    "info-join": { text: 'trat bei' },
    "info-enter": { text: 'tritt ein' },
    "info-owner": { text: 'Du bist der Besitzer' },
    "info-no-elements": { text: 'Diese Szene hat derzeit keine Elemente.' },

    "toolbox-text": { text: 'Werkzeugkasten' },
    "new-text": { text: 'Neu' },
    "locked-text": { text: 'Gesperrt' },
    "add-chair": { text: 'Stuhl hinzufügen' },
    "add-screen-share": { text: 'Bildschirmfreigabe hinzufügen' },
    "add-profile": { text: 'Profil hinzufügen' },
    "add-image-link": { text: 'Bild/Link hinzufügen' },
    "add-scene-change": { text: 'Szenenwechsel hinzufügen' },
    "add-youtube-video": { text: 'YouTube-Video hinzufügen' },
    "add-chess-game": { text: 'Schachspiel hinzufügen' },
    "add-bagless-room": { text: 'Füge einen Baglessraum hinzu' },
    "add-info-element": { text: 'Infoelement hinzufügent' },
    "add-input-field-guess": { text: 'Eingabe-Rätsel hinzufügen' },
    "input-field-guess": { text: 'Eingabe-Rätsel' },
    "edit-input-field-guess": { text: 'Eingabe-Rätsel bearbeiten' },
    "question-text": { text: 'Frage' },
    "correct-answer-text": { text: 'Richtige Antwort' },
    "input-field-guess-question-placeholder": { placeholder: 'Frage eingeben' },
    "input-field-guess-answer-placeholder": { placeholder: 'Richtige Antwort eingeben' },
    "input-field-guess-user-answer-placeholder": { placeholder: 'Ihre Antwort' },
    "input-field-guess-answer-hint": { text: 'Die Antwort wird sicher auf dem Server gespeichert, nicht in den Szenendaten.' },
    "input-field-guess-autoclose-true": { text: 'Bei richtiger Antwort automatisch schließen' },
    "input-field-guess-autoclose-false": { text: 'Bei falscher Antwort automatisch schließen' },
    "event-input-guess-open": { text: 'Öffnen' },
    "event-input-guess-close": { text: 'Schließen' },
    "event-user-answered-true": { text: 'Benutzer hat richtig geantwortet' },
    "event-user-answered-false": { text: 'Benutzer hat falsch geantwortet' },
    "action-input-guess-open": { text: 'Öffnen' },
    "action-input-guess-close": { text: 'Schließen' },
    "error-provide-question": { text: 'Bitte geben Sie eine Frage ein.' },
    "error-provide-correct-answer": { text: 'Bitte geben Sie die richtige Antwort ein.' },
    "error-provide-answer": { text: 'Bitte geben Sie eine Antwort ein.' },
    "error-check-answer-failed": { text: 'Antwort konnte nicht überprüft werden. Bitte erneut versuchen.' },
    "add-input-field": { text: 'Eingabefeld hinzufügen' },
    "input-field": { text: 'Eingabefeld' },
    "edit-input-field": { text: 'Eingabefeld bearbeiten' },
    "input-field-title-placeholder": { placeholder: 'Titel eingeben' },
    "input-field-body-placeholder": { placeholder: 'Text eingeben' },
    "input-field-placeholder-label": { text: 'Platzhalter' },
    "input-field-placeholder-placeholder": { placeholder: 'Ihre Antwort' },
    "input-field-user-placeholder": { placeholder: 'Ihre Antwort' },
    "input-field-key-label": { text: 'Feldschlüssel' },
    "input-field-key-placeholder": { placeholder: 'email' },
    "input-field-funnel-step-label": { text: 'Funnel-Schritt' },
    "input-field-funnel-step-placeholder": { placeholder: 'lead_email' },
    "input-field-validation-label": { text: 'Validierung' },
    "input-field-validation-required": { text: 'Pflichtfeld' },
    "input-field-validation-email": { text: 'E-Mail' },
    "input-field-validation-phone": { text: 'Telefon' },
    "input-field-validation-min-length": { text: 'Mindestlänge' },
    "input-field-validation-none": { text: 'Keine' },
    "input-field-min-length-label": { text: 'Mindestlänge' },
    "input-field-autoclose": { text: 'Nach dem Senden schließen' },
    "input-field-privacy-hint": { text: 'Antworten werden in Bagless mit der Amplitude-Session-ID gespeichert. Amplitude erhält nur den Funnel-Schritt, nicht den Wert.' },
    "event-input-field-open": { text: 'Öffnen' },
    "event-input-field-close": { text: 'Schließen' },
    "event-input-field-submitted": { text: 'Gesendet' },
    "event-input-field-validation-failed": { text: 'Validierung fehlgeschlagen' },
    "action-input-field-open": { text: 'Öffnen' },
    "action-open-input-field": { text: 'Eingabefeld öffnen' },
    "action-open-embedded-webpage": { text: 'Eingebettete Webseite öffnen' },
    "connect-event-select-input-field": { text: 'Bitte wählen Sie ein Eingabefeld' },
    "action-input-field-close": { text: 'Schließen' },
    "error-provide-input": { text: 'Bitte geben Sie einen Wert ein.' },
    "error-invalid-email": { text: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.' },
    "error-invalid-phone": { text: 'Bitte geben Sie eine gültige Telefonnummer ein.' },
    "error-min-length": { text: 'Bitte geben Sie einen längeren Wert ein.' },
    "error-value-too-long": { text: 'Dieser Wert ist zu lang.' },
    "error-save-input-failed": { text: 'Antwort konnte nicht gespeichert werden. Bitte erneut versuchen.' },
    "send-text": { text: 'Senden' },
    "add-paypal-donation": { text: 'PayPal-Spende hinzufügen' },
    "add-product": { text: 'Produkt hinzufügen' },
    "add-embedded-webpage": { text: 'Eingebettete Webseite hinzufügen' },
    "expand-toolbox": { text: 'Toolbox erweitern' },

    "edit-chair": { text: 'Stuhl bearbeiten' },
    "edit-screen-share": { text: 'Bildschirmfreigabe bearbeiten' },
    "edit-profile": { text: 'Profil bearbeiten' },
    "edit-image-link": { text: 'Bild/Link bearbeiten' },
    "edit-scene-change": { text: 'Szenenwechsel bearbeiten' },
    "edit-youtube-video": { text: 'YouTube-Video bearbeiten' },
    "edit-chess-game": { text: 'Schachspiel bearbeiten' },
    "edit-bagless-room": { text: 'Füge einen Baglessraum bearbeitent' },
    "edit-info-element": { text: 'Infoelement bearbeitent' },
    "edit-paypal-donation": { text: 'PayPal-Spende bearbeiten' },
    "edit-product": { text: 'Produkt bearbeiten' },
    "add-video": { text: 'Video hinzufügen (veraltet)' },
    "edit-embedded-webpage": { text: 'Eingebettete Webseite bearbeiten' },

    "chair": { text: 'Stuhl' },
    "screen-share": { text: 'Bildschirmfreigabe' },
    "profile": { text: 'Profil' },
    "image-link": { text: 'Bild/Link' },
    "scene-change": { text: 'Szenenwechsel' },
    "youtube-video": { text: 'YouTube-Video' },
    "chess-game": { text: 'Schachspiel' },
    "bagless-room": { text: 'Füge einen Baglessraum' },
    "info-element": { text: 'Info-Element' },
    "video-gallery-element": { text: 'Video-Element' },
    "paypal-donation": { text: 'PayPal-Spende' },
    "product": { text: 'Produkt' },
    "embedded-webpage": { text: 'Eingebettete Webseite' },

    "share-location-text": { text: 'Ort teilen' },
    "room-url-placeholder": { placeholder: 'Zimmer URL' },
    "copy-link-value": { value: 'Link kopieren' },
    "show-interaction-points": { text: 'Interaktionspunkte anzeigen' },
    "hide-interaction-points": { text: 'Interaktionspunkte ausblenden' },

    "add-text": { text: 'Hinzufügen' },
    "scene-change-target": { text: 'Ziel Szene' },
    "scene-change-image": { text: 'Ziel Bild' },
    "upload-thumb-image-title": { title: 'Vorschaubild hochladen' },
    "target-scene-text": { text: 'Zielszene' },
    "change-text": { text: 'Veränderung' },
    "open-link-new-window": { text: 'Link in neuem Fenster öffnen' },
    "link-url-text": { text: 'URL verlinken' },
    "link-image-text": { text: 'Bild verlinken' },
    "upload-img-title": { title: 'Bild hochladen' },
    "delete-img-title": { title: 'Bild löschen' },
    "add-products-text": { text: 'Produkte hinzufügen' },
    "edit-products-text": { text: 'Produkte bearbeiten' },
    "add-up-to-products": { text: 'Bis zu 10 Produkte hinzufügen' },
    "product-name-text": { text: 'Produktname' },
    "required-text": { text: 'Erforderlich' },
    "product-name-input": { value: 'Produktname', placeholder: 'Produktname' },
    "product-image-text": { text: 'Produktbild' },
    "upload-product-image-title": { title: 'Produktbild hochladen' },
    "delete-product-image-title": { title: 'Produktbild löschen' },
    "best-img-resolution-product": { text: 'Beste Auflösung 800x400' },
    "product-desc-text": { text: 'Produktbeschreibung' },
    "product-desc-placeholder": { placeholder: 'Produktbeschreibung' },
    "price-text": { text: 'Preis' },
    "price-placeholder": { text: 'Preis' },
    "product-url-text": { text: 'Produkt URL' },
    "button-label-text": { text: 'Beschriftung' },
    "shop-button-placeholder": { placeholder: 'GEGENSTAND KAUFEN' },
    "add-more-text": { text: 'mehr hinzufügen' },
    "save-changes-text": { text: 'Änderungen speichern' },
    "who-can-stream-notification": { text: 'Wer kann auf diesem Bildschirm streamen?' },
    "everyone-text": { text: 'Alle' },
    "owner-text": { text: 'Eigentümer' },
    "on-request-text": { text: 'auf Anfrage' },
    "choose-your-layout": { text: 'Wählen Sie Ihr Layout' },
    "cover-image-text": { text: 'Titelbild' },
    "title-text": { text: 'Titel' },
    "description-text": { text: 'Beschreibung' },
    "desc1-text": { text: 'Beschreibung 1' },
    "desc2-text": { text: 'Beschreibung 2' },
    "button-text": { text: 'Taste' },
    "simple-text": { text: 'Sinfach' },
    "image-text": { text: 'Bild' },
    "complex-text": { text: 'Komplex' },
    "next-text": { text: 'Nächste' },
    "info-element-placeholder": { placeholder: 'Info-Element' },
    "upload-info-element-title": { title: 'Bild des Info-Elements hochladen' },
    "title-placeholder": { placeholder: 'Titel' },
    "info-drag-and-drop-img": { text: 'Ziehen Sie das Bild per Drag-and-Drop in diesen Bereich, um es hochzuladen' },
    "info-drag-and-drop-video": { text: 'Ziehen Sie das video per Drag-and-Drop in diesen Bereich, um es hochzuladen' },
    "supported-files-text": { text: 'Unterstützte Dateien' },
    "edit-info-element": { text: 'Info Element bearbeiten' },
    "url-or-id": { text: 'URL oder ID' },
    "dynamic-avatar-img": { text: 'Dynamisches Avatarbild' },
    "always-latest-avatar": { text: 'Verwende für dieses Objekt immer mein neustes Profilbild' },
    "profile-avatar-text": { text: 'Profilbild' },
    "upload-profile-img-title": { title: 'Profilbild hochladen' },
    "delete-profile-img-title": { title: 'Profilbild löschen' },
    "confirm-dialog-text": { text: 'Bestätigungsdialog' },
    "connect-to-bagless-room": { text: 'Verknüpfe Bagless Raum' },
    "choose-target-room": { text: 'Wähle Zielraum' },
    "select-scene-text": { text: 'Wähle Szene' },
    "additional-help-visit": { text: 'Für weitere Hilfe, besuche' },
    "donation-img-title": { title: 'Spendenbild' },
    "edit-image-gallery-element": { text: 'Bildergalerie-Element bearbeiten' },
    "edit-video-gallery-element": { text: 'Videogalerie-Element bearbeiten' },
    "donation-image": { title: 'Spendenbild', text: 'Spendenbild' },
    "delete-video-title": { title: 'Video löschen' },
    "upload-welcome-screen-video-title": { title: 'Willkommensvideo hochladen' },
    "video-text": { text: 'Video' },
    "upload-video-text": { text: 'Video hochladen' },
    "upload-video-title": { title: 'Video hochladen' },
    "welcome-screen-editor": { text: 'Willkommensbild Editor' },

    "iframe-text": { text: 'iFrame' },
    "online-text": { text: 'Online' },
    "draft-modal-title": { text: 'Entwurfsraum' },
    "draft-modal-info-message": { text: 'Bitte geben Sie einen Namen für den Raum ein und legen Sie seine Koordinaten fest' },
    "paid-location-text": { text: "Bezahlter Standort" },
    "paid-location-tooltip": { text: "Der Zugang wird gegen Bezahlung gewährt" },
    "payment-setup-title": { text: 'Einrichtung der Standortzahlung' },
    "duration-text": { text: 'Dauer' },
    "until-text": { text: 'bis um' },
    "from-date-title": { title: 'Ab Datum' },
    "until-date-title": { title: 'Bis zum Datum' },
    "or-text": { text: 'oder' },
    "days-text": { text: 'Tage' },
    "email-text": { text: 'E-Mail' },
    "location-desc-text": { text: 'Ortsbeschreibung' },

    "user-profile-text": { text: 'Benutzerprofil' },
    "user-profile-text-saved": { text: 'Benutzerprofil gespeichert' },
    "minimize-text": { text: 'Minimieren' },
    "flip-board-text": { text: 'Tafel kippen' },
    "restart-text": { text: 'Neu starten' },
    "quit-game-text": { text: 'Spiel verlassen' },
    "game-status-text": { text: 'Spielstatus' },
    "quit-text": { text: 'Verlassen' },
    "join-public-stage": { text: 'Sie sind dabei, einen öffentlichen Ort zu betreten. Das bedeutet, dass Sie unabhängig von Ihrem eigenen Bundesland Audio- und Videostreams anderer Personen erhalten.' },
    "welcome-aboard": { text: 'Willkommen an Bord!' },
    "start-exploring": { text: 'Beginnen Sie mit der Erkundung' },
    "crop-image": { text: 'Bild zuschneiden' },
    "landscape-aspect": { text: 'Landschaft (16:9)' },
    "portrait-aspect": { text: 'Porträt (9:16)' },
    "choosen-avatar": { text: 'Ausgewählter Avatar' },
    "please-select-avatar": { text: 'Bitte wählen Sie Ihr Avatar-Bild aus.' },
    "restricted-access-text": { text: 'Eingeschränkter Zugang' },
    "help-text": { text: 'Hilfe' },
    "select-stream-source": { text: 'Streamquelle auswählen' },
    "start-streaming-value": { value: 'Starten Sie das Streamen' },
    "screen": { text: 'Bildschirm' },
    "offline-message-sent": { text: 'Benachrichtigung gesendet' },
    "success-contributore": { text: 'Mitwirkender hinzugefügt' },
    "filters-text": { text: 'Filter' },
    "update-profile": { text: 'Profil aktualisieren' },
    "go-back-text": { text: 'Geh zurück' },
    "custom-icon-text": { text: 'Custom Icon' },
    "request-permission-text": { text: 'Bitten Sie um Erlaubnis für eine Kamera und ein Mikrofon' },
    "request-permission-you-must-text": { text: 'Sie müssen die Berechtigungen aktivieren, um alle Funktionen nutzen zu können.' },
    "user-cancelled-share-text": { text: 'Das Teilen des Bildschirms wurde abgebrochen' },
    "support-ticket-text": { text: 'Support-Ticket erstellen' },
    "no-empty-seat-text": { text: 'Keine freien Plätze verfügbar' },
    "empty-seat-reminder-text": { text: 'Erinnerung an leeren Sitz' },

    "back-to-home": { text: "Zurück zur Startseite" },
    "approve-text": { text: "Genehmigen" },
    "reject-text": { text: "Ablehnen" },
    "ok-text": { text: "OK" },
    "session-locked-title": { text: "Sitzung gesperrt" },
    "session-locked-message": { text: "Sie haben den Raum gesperrt. Andere Benutzer können den Raum erst bearbeiten, wenn Sie die Sperre aufheben oder nach 30 Minuten Inaktivität." },
    "session-unlocked-title": { text: "Sitzung entsperrt" },
    "session-unlocked-message": { text: "Sie haben den Raum entsperrt. Andere Benutzer können nun die Sitzung übernehmen." },
    "session-locked-by-title": { text: "Sitzung gesperrt" },
    "session-locked-by-message": { text: "Dieser Raum wird von <strong>{userName}</strong> bearbeitet, aber die Sitzung ist gesperrt.<br /> Bitte kontaktieren Sie <strong>{userName}</strong>, um die Sperre aufzuheben." },
    "session-in-progress-title": { text: "Sitzung wird von einem anderen Benutzer bearbeitet" },
    "session-in-progress-message": { text: "Dieser Raum wird bereits von <strong>{userName}</strong> bearbeitet.<br />Möchten Sie die Sitzung übernehmen?" },
    "takeover-button": { text: "Übernehmen" },
    "takeover-request-title": { text: "Übernahmeanfrage" },
    "takeover-request-message": { text: "<strong>{userName}</strong> hat angefragt, die Sitzung zu übernehmen.<br />Beachten Sie, dass Sie Ihre Änderungen verlieren, wenn Sie die Anfrage genehmigen.<br />Möchten Sie die Anfrage genehmigen?" },
    "takeover-pending-title": { text: "Sitzungsübernahme ausstehend" },
    "takeover-pending-message": { text: "Wartet darauf, dass <strong>{Benutzername}</strong> die Sitzungsübernahme genehmigt.<br />Wenn es keine Aktion von <strong>{Benutzername}</strong> gibt, wird sie automatisch in {countdown} freigeschaltet." },
    "takeover-approved-title": { text: "Sitzungsübernahme genehmigt" },
    "takeover-approved-message": { text: "<strong>{userName}</strong> hat die Sitzungsübernahme genehmigt. Sie können jetzt den Raum bearbeiten." },
    "takeover-rejected-title": { text: "Sitzungsübernahme abgelehnt" },
    "takeover-rejected-message": { text: "<strong>{userName}</strong> hat die Sitzungsübernahme abgelehnt. Bitte kontaktieren Sie <strong>{userName}</strong>, um die Sperre aufzuheben." },
    "takeover-approved-by-message": { text: "Sie haben die Sitzungsübernahme genehmigt. <strong>{userName}</strong> kann jetzt den Raum bearbeiten." },
    "takeover-cancelled-title": { text: "Sitzungsübernahme abgebrochen" },
    "deactivate-session-lock-message": { text: "Sind Sie noch da? Wir werden Sie in {countdown} abmelden." },
    "activate-session-lock-message": { text: "Sie sind auf inaktiv gesetzt. Möchten Sie wieder aktiviert werden?" },
    "auto-take-seat-text": { text: 'Auto-Take-Seat-Link' },
    "landscape-text": { text: 'Bitte drehen Sie Ihr Gerät in den Querformatmodus' },
    "location-menu-text": { text: 'Standortmenü' },
    "location-menu-jump-to": { text: 'Zu Standort springen' },
    "location-menu-navigation-title": { text: 'Navigation' },
    "drop-down-available-text": { text: 'Dropdown available' },
    "chats": { text: "Chats" },
    "current-room": { text: "Raumchat" },
    "latest-chats": { text: "Neueste Chats" },
    "not-found-selected-device": { text: 'Ausgewähltes Gerät nicht gefunden' },
    "socket-connection-lost": { "text": "Verbindung zum Bagless-Server verloren" },
    "socket-reconnected": { "text": "Wieder mit dem Bagless-Server verbunden" },
    "socket-reconnecting": { "text": "Wiederverbindung mit dem Bagless-Server" },
    "network-connection-lost": { "text": "Keine Internetverbindung" },
    "network-poor-connection": { "text": "Schlechte Internetverbindung" },
    "reconnect": { "text": "Neu verbinden" },
    "device-select-join-with-media": { "text": "Mit Audio und Video teilnehmen" },
    "device-select-join-as-viewer": { "text": "Nur als Zuschauer teilnehmen" },
    "device-select-join": { "text": "Mitmachen" },
    "device-select-cancel": { "text": "Abbrechen" },
    "exit-app-confirm": { text: 'Sind Sie sicher, dass Sie den Space verlassen wollen?' },
    "no-empty-screen-share-seats": { text: 'Keine freien Bildschirmfreigabenplätze verfügbar' },
    "error-please-take-seat": { text: 'Bitte nehmen Sie einen Sitzplatz ein' },
    "leave-game-or-standup": { text: 'Spiel verlassen oder aufstehen?' },
    "standup-text": { text: 'Aufstehen' },
    "leave-game-text": { text: 'Spiel verlassen' },
    "chess-game-locked": { text: 'Das Spiel ist von einem Spieler gesperrt, Sie können jetzt nicht eintreten, bitte warten Sie, bis das Spiel beendet ist.' },
    "enter-chess-but-you-are-sitting": { text: 'Wenn Sie das Schachspiel betreten, werden Sie von Ihrem Sitzplatz aufstehen. Möchten Sie fortfahren?' },
    "confirm-end-one-on-one-to-continue": { text: 'Dadurch wird dein 1:1-Anruf beendet. Möchtest du fortfahren?' },
    "end-call-and-continue": { text: 'Anruf beenden und fortfahren' },
    "restart-game-confirm": { text: 'Sind Sie sicher, dass Sie das Spiel neu starten möchten?' },
    "is-inviting-you-to-join-room": { text: 'lädt Sie ein, den Raum zu betreten' },
    "start-tour-title": { text: 'Tour starten' },
    "start-tour-btn": { text: 'Tour starten' },
    "start-tour-name-placeholder": { placeholder: 'Gib deiner Tour einen Namen' },
    "start-tour-visibility-public": { text: 'Öffentlich' },
    "start-tour-visibility-private": { text: 'Privat' },
    "start-tour-visibility-public-desc": { text: 'Jeder ist eingeladen mitzumachen.' },
    "start-tour-visibility-private-desc": { text: 'Nur auf Anfrage durch den Guide.' },
    "start-tour-one-to-one": { text: '1:1-Tour' },
    "start-one-on-one-tour-text": { text: '1:1-Tour starten' },
    "start-one-on-one-user-offline": { text: 'Diese Person ist nicht online.' },
    "start-one-on-one-unavailable": { text: 'Du kannst in diesem Space keine Tour starten.' },
    "one-to-one-tour-closed": { text: 'Dies ist eine private 1:1-Tour' },
    "one-to-one-tour-seat-taken": { text: 'Diese 1:1-Tour hat bereits einen Gast' },
    "start-tour-default-name": { text: 'Tour von {userName}' },
    "end-tour-confirm": { "text": "Die Tour wird für alle beendet und alle Aktivitäten werden gestoppt." },
    "end-tour-confirm-title": { "text": "Tour beenden" },
    "end-tour-confirm-btn": { "text": "Tour beenden" },
    "exit-tour-confirm": { "text": "Sind Sie sicher, dass Sie die Tour verlassen möchten?" },
    "exit-tour-confirm-btn": { "text": "Verlassen" },
    "exit-tour-choice": { text: "Zur Gästeliste oder die Tour verlassen?" },
    "exit-tour-choice-guest": { text: "Gästeliste" },
    "exit-tour-choice-exit": { text: "Tour verlassen" },
    "exit-tour": { text: "Tour verlassen" },
    "exit-podium": { text: "Podium verlassen" },
    "exit-podium-confirm": { text: "Podium verlassen? Sie bleiben als Gast in der Tour." },
    "exit-podium-confirm-btn": { text: "Podium verlassen" },
    "would-you-like-to-take-a-seat-or-invite-guest": { text: 'Möchten Sie einen Sitzplatz nehmen oder einen Gast einladen?' },
    "exit-game-confirm": { text: 'Sind Sie sicher, dass Sie das Spiel verlassen möchten?' },
    "language-menu-title": "Sprache",
    "language-menu-english": "Englisch",
    "language-menu-german": "Deutsch",
    "language-menu-romanian": "Rumänisch",
    "spaces-header-title": { text: 'Bagless durch die Welt. Finde deine Tour, deinen Space deine Freunde' },
    "spaces-online-friends-title": { text: 'Freunde' },
    "spaces-friends-offline": { text: 'Offline' },
    "spaces-online-friends-loading": { text: 'Freunde werden geladen...' },
    "spaces-online-friends-empty": { text: 'Keine Freunde online' },
    "spaces-online-friends-none": { text: 'Du hast noch keine Freunde' },
    "spaces-online-friends-error": { text: 'Freunde konnten nicht geladen werden' },
    "spaces-search-placeholder": { placeholder: 'Wonach suchst du?' },
    "spaces-create-new": { text: 'Neuen Space erstellen' },
    "spaces-order-by": { text: 'Sortieren nach' },
    "spaces-sort-by": { text: 'Sortieren nach' },
    "spaces-creation-date": { text: 'Erstellungsdatum' },
    "spaces-update-date": { text: 'Aktualisierungsdatum' },
    "spaces-space-name": { text: 'Space-Name' },
    "spaces-active-users": { text: 'Aktive Benutzer' },
    "spaces-number-of-visitors": { text: 'Anzahl der Besucher' },
    "spaces-distance": { text: 'Entfernung' },
    "spaces-sort": { text: 'Sortieren' },
    "spaces-filter": { text: 'Filter:' },
    "spaces-space-language": { text: 'Space-Sprache' },
    "spaces-all-spacetags": { text: 'Alle Space-Tags' },
    "spaces-enter-scene": { text: 'Szene betreten' },
    "spaces-updated": { text: 'Aktualisiert:' },
    "error-screen-share": { text: 'Bildschirmfreigabe ist nicht erlaubt' },

    // Newer feature translations
    "tour-mode-name-text": { text: "Tour-Modus" },
    "disable-autorotate-name-text": { text: "Autorotation deaktivieren" },
    "disable-postits-name-text": { text: "Post-its deaktivieren" },
    "disable-chat-name-text": { text: "Chat deaktivieren" },
    "disable-user-list-name-text": { text: "Benutzerliste deaktivieren" },
    "navigation-menu-name-text": { text: "Navigationsmenü" },
    "navigation-menu-editor-title": { text: "Navigations-Editor" },
    "navigation-menu-active-label": { text: "Navigation aktiv" },
    "navigation-menu-add-entry": { text: "+ Menüeintrag hinzufügen" },
    "navigation-menu-entry-editor-title": { text: "Menüeintrag" },
    "navigation-menu-entry-name-label": { text: "Name" },
    "navigation-menu-entry-type-label": { text: "Typ" },
    "navigation-menu-entry-room-label": { text: "Raum" },
    "navigation-menu-entry-url-label": { text: "URL" },
    "navigation-menu-entry-visible-label": { text: "Sichtbar in Navigation" },
    "navigation-menu-type-room": { text: "Raum" },
    "navigation-menu-type-url": { text: "URL" },
    "navigation-menu-room-missing": { text: "Raum fehlt" },
    "hide-language-selection-name-text": { text: "Raumsprache sperren" },
    "tour-mode-only-text": { text: "Neu" },
    "add-image-gallery": { text: "Bildergalerie" },
    "embed-room-text": { text: "Kopieren" },
    "link-copied": { text: "In die Zwischenablage kopiert" },
    "private-rooms-available": { text: "Private Räume sind nur für angemeldete Benutzer verfügbar" },
    "guest-modal-why-should-i-login": { text: "Warum sollte ich mich anmelden?" },
    "guest-modal-features": { text: "Für mehr Funktionen und Möglichkeiten können Sie" },
    "autoplay": { text: "Autoplay" },

    "user-profile-title": { text: 'Bagless Profil' },
    "user-status-online": { text: 'Online' },
    "user-location-label": { text: 'Standort:' },
    "user-title-label": { text: 'Titel:' },
    "user-company-label": { text: 'Unternehmen:' },
    "user-website-label": { text: 'Webseite:' },
    "user-birthday-label": { text: 'Geburtstag:' },
    "user-interests-label": { text: 'Interessen:' },
    "spaces-heading": { text: 'Räume' },
    "error-heading": { text: 'Fehler!' },
    "space-language-label": { text: 'Raumsprache' },
    "location-distance-label": { text: 'Standortentfernung' },
    "clear-button": { text: 'Löschen' },
    "apply-button": { text: 'Anwenden' },

    "administration-text": { text: 'Verwaltung' },
    "admin-spaces-management": { text: 'Spaces Verwaltung' },
    "admin-users-management": { text: 'Benutzerverwaltung' },
    "admin-roles-management": { text: 'Rollenverwaltung' },
    "admin-plans-management": { text: 'Planverwaltung' },
    "admin-self-check": { text: 'Selbstprüfung' },
    "admin-portal-settings": { text: 'Portal-Einstellungen' },
    "admin-vapi-agents": { text: 'VAPI-Agenten' },
    "admin-vapi-conversations": { text: 'VAPI-Gespräche' },
    "maintenance-title": { text: 'Wartungsarbeiten' },
    "maintenance-description": { text: 'Wir aktualisieren derzeit das Portal. Bitte versuchen Sie es später erneut.' },
    "maintenance-countdown-label": { text: 'Geschätzte verbleibende Zeit' },
    "maintenance-reload": { text: 'Seite neu laden' },
    "maintenance-admin-login": { text: 'Admin-Anmeldung' },
    "maintenance-admin-login-hint": { text: 'Nur Administrator-Anmeldung' },
    "report-bug-text": { text: 'Help Center' },
    "help-center-text": { text: 'Help Center' },

    "footer-bagless-text": { text: 'Bagless' },
    "footer-impressum-text": { text: 'Impressum' },
    "footer-privacy-text": { text: 'Datenschutz' },
    "footer-terms-text": { text: 'Nutzungsbedingungen' },
    "footer-cookie-text": { text: 'Cookie-Richtlinien' },

    "register-title": { text: 'Neues Konto registrieren' },
    "login-title": { text: 'Anmelden' },
    "email-sent-title": { text: 'E-Mail gesendet' },
    "resend-confirmation-title": { text: 'Bestätigungs-E-Mail erneut senden' },
    "forgot-password-title": { text: 'Passwort vergessen' },
    "reset-password-title": { text: 'Passwort zurücksetzen' },
    "email-change-title": { text: 'E-Mail ändern' },
    "email-change-note": { text: 'Geben Sie Ihre neue E-Mail-Adresse und Ihr aktuelles Passwort ein, um Ihre E-Mail zu ändern.' },
    "email-change-button": { text: 'E-Mail ändern' },
    "email-change-email-note": { text: 'Bitte überprüfen Sie Ihre E-Mail auf einen Bestätigungslink, um den E-Mail-Änderungsprozess abzuschließen.' },

    "password-change-title": { text: 'Passwort ändern' },
    "password-change-note": { text: 'Geben Sie Ihr aktuelles Passwort und ein neues Passwort ein, um Ihre Kontosicherheit zu aktualisieren.' },
    "password-change-button": { text: 'Passwort ändern' },
    "password-changed-title": { text: 'Passwort geändert' },
    "password-changed-note": { text: 'Ihr Passwort wurde erfolgreich aktualisiert.' },
    "password-set-title": { text: 'Passwort festlegen' },
    "password-set-note": { text: 'Erstellen Sie ein Passwort, um die E-Mail/Passwort-Anmeldung für Ihr Konto zu aktivieren.' },
    "password-set-button": { text: 'Passwort festlegen' },

    "password-requirements": { text: 'Passwort muss Großbuchstaben, Kleinbuchstaben, Zahl und Sonderzeichen enthalten (6-72 Zeichen).' },
    "terms-acceptance": { text: 'Mit der Registrierung akzeptieren Sie' },
    "terms-and-privacy": { text: 'Allgemeine Geschäftsbedingungen und Datenschutzrichtlinie' },
    "register-button": { text: 'Neues Konto registrieren' },
    "login-button": { text: 'Anmelden' },
    "login-link": { text: 'Anmelden' },
    "register-link": { text: 'Konto registrieren' },
    "remember-me": { text: 'Für das nächste Mal merken' },
    "magic-link-button": { text: 'Anmeldelink erhalten' },
    "forgot-password-link": { text: 'Passwort vergessen?' },
    "register-google": { text: 'Mit Google registrieren' },
    "login-google": { text: 'Mit Google anmelden' },
    "already-registered-text": { text: 'Bereits registriert?' },
    "dont-have-account-yet": { text: 'Noch kein Konto?' },

    "verify-email-note": { text: 'Bitte überprüfen Sie Ihre E-Mail für weitere Anweisungen zur Verifizierung Ihres Kontos' },
    "magic-link-note": { text: 'Bitte überprüfen Sie Ihren Posteingang und klicken Sie auf den Link, um sich anzumelden.' },
    "reset-password-note": { text: 'Bitte überprüfen Sie Ihre E-Mail für weitere Anweisungen zum Zurücksetzen Ihres Passworts' },
    "resend-confirmation-note": { text: 'Wenn Sie die Bestätigungs-E-Mail nicht erhalten haben, können Sie eine neue anfordern, indem Sie unten Ihre E-Mail-Adresse eingeben.' },
    "forgot-password-note": { text: 'Bitte geben Sie Ihre E-Mail-Adresse ein. Ein Link zum Zurücksetzen des Passworts wird dorthin gesendet.' },
    "reset-password-enter-note": { text: 'Bitte geben Sie unten Ihr neues Passwort ein.' },

    "resend-button": { text: 'Erneut senden' },
    "send-button": { text: 'Senden' },
    "reset-password-button": { text: 'Passwort zurücksetzen' },
    "back-to-login": { text: 'Zurück zur Anmeldung' },

    // Admin section
    "admin-bulk-delete": { text: 'Mehrere löschen' },
    "admin-bulk-edit-roles": { text: 'Rollen bearbeiten' },
    "admin-bulk-update-privacy": { text: 'Datenschutz aktualisieren' },
    "admin-create-new-user": { text: 'Neuen Benutzer erstellen' },
    "admin-create-new-plan": { text: 'Neuen Plan erstellen' },
    "admin-create-new-world": { text: 'Neue Welt erstellen' },
    "admin-create-new-world-draft": { text: 'Neuen Welt-Entwurf erstellen' },
    "admin-create-new-role": { text: 'Neue Rolle erstellen' },
    "admin-create-new-feature": { text: 'Neue Funktion erstellen' },
    "admin-add-new-permission": { text: 'Neue Berechtigung hinzufügen' },
    "admin-search-button": { text: 'Suchen' },
    "admin-search-placeholder": { placeholder: 'Suchen...' },
    "admin-plans-tab": { text: 'Pläne' },
    "admin-features-tab": { text: 'Funktionen' },
    "admin-roles-tab": { text: 'Rollen' },
    "admin-permissions-tab": { text: 'Berechtigungen' },
    "this-space": { text: "Dieser Raum" },
    "space-contributors-text": { text: "Raummitwirkende" },
    "admin-space-type": { text: 'Space-Typ' },
    "admin-space-type-public": { text: 'Öffentlich' },
    "admin-space-type-premium": { text: 'Premium' },
    "support-text": { text: "Support" },
    "updates-and-releases-text": { text: "Updates und Veröffentlichungen" },
    "admin-users-active": { text: "Aktiviert" },
    "admin-users-inactive": { text: "Inaktiv" },
    "exit-chess-game": { text: "Dies wird das Schachspiel beenden" },
    "error-not-available-in-current-plan": { text: "Diese Aktion ist in Ihrem aktuellen Tarif nicht verfügbar. Bitte upgraden Sie, um diese Funktion zu nutzen." },
    "not-available-in-free-plan": { text: "Diese Funktion ist in der Free-Plan nicht verfügbar" },
    "error-not-available-in-guest-plan": { text: "Bitte anmelden, um diese Funktion zu nutzen" },
    "draft-mode-name-text": { text: "Entwurf-Modus" },
    "disable-guest-restrictions-name-text": { text: "Gästeinschränkungen deaktivieren" },
    "cancel-subscription-title": { text: "Abonnement kündigen" },
    "cancel-subscription-warning": { text: "Sind Sie sicher, dass Sie Ihr Abonnement kündigen möchten? Ihr Abonnement bleibt bis zum Ende Ihres aktuellen Abrechnungszeitraums aktiv. Es wird kein Rückerstattung gewährt." },
    "cancel-subscription-note": { text: "Nach der Kündigung bleibt Ihr Abonnement bis zum Ende Ihres aktuellen Abrechnungszeitraums aktiv." },
    "cancel-subscription-confirm": { text: "Ja, mein Abonnement kündigen" },
    "cancel-subscription-cancel": { text: "Nein, mein Abonnement behalten" },
    "premium-space-text": { text: "Premium Raum" },
    "tune-menu-space-settings": { text: "Raum-Einstellungen" },
    "show-space-info": { text: "Raum-Info anzeigen" },
    "ai-tokens-list": { text: "KI-Token" },
    "add-ai-token": { text: "Token hinzufügen" },
    "edit-ai-token": { text: "KI-Token bearbeiten" },
    "ai-tokens-help": { text: "Personalisierter extra VAPI-Prompt. Teile den Token-Link, damit die KI den Kontext dieses Besuchers lädt." },
    "ai-tokens-default-link": { text: "Standard-Link (ohne Token)" },
    "ai-token-name": { text: "Name" },
    "ai-token-value": { text: "Token" },
    "ai-token-value-help": { text: "Wird in der Share-URL als AItoken verwendet. Leer lassen zum automatischen Erzeugen." },
    "ai-token-generate": { text: "Erzeugen" },
    "ai-token-prompt": { text: "Prompt" },
    "ai-token-prompt-help": { text: "Wird beim Öffnen des Raums mit diesem Token als tokenPrompt an VAPI gesendet. Im Dashboard-Assistenten {{tokenPrompt}} verwenden." },
    "ai-token-calls": { text: "Calls" },
    "ai-token-copy-link": { text: "Link kopieren" },
    "ai-token-viewer-report": { text: "Report zum Viewer" },
    "ai-token-required-fields": { text: "Name und Prompt sind erforderlich" },
    "ai-token-save-failed": { text: "Token konnte nicht gespeichert werden" },
    "ai-token-delete-confirm": { text: "Diesen KI-Token löschen?" },
    "ai-token-delete-failed": { text: "Token konnte nicht gelöscht werden" },
    "ai-token-report-empty": { text: "Noch keine Viewer-Calls." },
    "no-ai-tokens-text": { text: "Noch keine KI-Token." },
    "space-info-title": { text: "Raum-Info" },
    "space-name-label": { text: "Raum-Name:" },
    "space-description-label": { text: "Beschreibung:" },
    "space-type-label": { text: "Typ:" },
    "space-visitors-label": { text: "Aktuelle Besucher:" },
    "already-friends-text": { text: "Bereits befreundet" },
    "add-as-friend-text": { text: "Als Freund hinzufügen" },
    "space-select-auth-required": { text: "Du musst dich zuerst anmelden, um einen neuen Space zu erstellen" },
    "space-select-differences-question": { text: "Was ist der Unterschied zwischen öffentlichen und Premium-Spaces?" },
    "space-select-type-select-question": { text: "Welche Art von Space möchtest du erstellen?" },
    "space-select-upgrade-required": { text: "Du musst upgraden, um einen Premium-Space zu erstellen" },
    "space-select-out-of-quota": { text: "Du hast keine Premium-Spaces mehr übrig" },
    "public-space-text": { text: "Öffentlicher Space" },
    "premium-space-text": { text: "Premium-Space" },
    "go-to-subscription-page": { text: "Zur Abonnement-Seite" },
    "about-bagless": { text: "Über" },
    "subscription-status-active": { "text": "Aktiv" },
    "subscription-status-trialing": { "text": "Testphase" },
    "subscription-status-canceled": { "text": "Storniert" },
    "subscription-status-incomplete": { "text": "Unvollständig" },
    "subscription-status-incomplete_expired": { "text": "Unvollständig abgelaufen" },
    "subscription-status-past_due": { "text": "Überfällig" },
    "subscription-status-unpaid": { "text": "Unbezahlt" },
    "subscription-status-paused": { "text": "Pausiert" },
    "subscription-interval-day-display": { "text": "tägliche Zahlung" },
    "subscription-interval-week-display": { "text": "wöchentliche Zahlung" },
    "subscription-interval-month-display": { "text": "monatliche Zahlung" },
    "subscription-interval-year-display": { "text": "jährliche Zahlung" },
    "subscription-confirm-upgrade": { "text": "Möchten Sie Ihr Abonnement wirklich upgraden?" },
    "subscription-confirm-downgrade": { "text": "Möchten Sie Ihr Abonnement wirklich downgraden?" },
    "notification-setting-coming-soon": { text: "Hier finden Sie bald Ihre Benachrichtigungseinstellungen." },
    "planned-guided-tour-coming-soon": { text: "Hier finden Sie bald Ihre geplanten geführten Touren." },
    "room-free-text": { text: "Meine Freien Räume" },
    "room-premium-text": { text: "Meine Premium-Räume" },
    "take_this_seat_to_play_as_black": { text: "Nimm diesen Sitz, um als Schwarz zu spielen" },
    "take_this_seat_to_play_as_white": { text: "Nimm diesen Sitz, um als Weiß zu spielen" },
    "take_a_seat_to_talk_with_others": { text: "Nimm einen Sitz, um mit anderen zu sprechen" },
    "make-space-premium-question": { text: "Möchten Sie diesen Space wirklich Premium machen?" },
    "make-space-public-question": { text: "Möchten Sie diesen Space wirklich öffentlich machen? Sie werden einige Funktionen verpassen!" },
    "not-invited-to-private-tour": { text: "Sie sind nicht eingeladen für diese private Tour" },

    // BuyMoreSpacesModal translations
    "manage-premium-spaces-title": { text: "Zusätzliche Premium-Spaces verwalten" },
    "manage-premium-spaces-desc": { text: "Verwenden Sie den Schieberegler, um Ihre zusätzlichen Premium-Spaces anzupassen. Nach rechts bewegen zum Kaufen, nach links zum Reduzieren und Gutschrift erhalten." },
    "current-spaces-text": { text: "Aktuelle Spaces:" },
    "number-of-spaces-text": { text: "Ziel-Anzahl der Spaces:" },
    "price-per-space-text": { text: "Preis pro Space:" },
    "total-cost-text": { text: "Gesamtkosten:" },
    "total-credit-text": { text: "Gesamtgutschrift:" },
    "cancel-button-text": { text: "Abbrechen" },
    "proceed-checkout-text": { text: "Zur Kasse" },
    "processing-text": { text: "Verarbeitung..." },
    "confirm-buy-spaces-title": { text: "Kauf bestätigen" },
    "confirm-buy-spaces-message": { text: "Sind Sie sicher, dass Sie {quantity} zusätzliche Premium {spaces} für {amount} kaufen möchten?" },
    "confirm-downgrade-spaces-title": { text: "Downgrade bestätigen" },
    "confirm-downgrade-spaces-message": { text: "Sind Sie sicher, dass Sie {quantity} Premium {spaces} downgraden möchten? Sie erhalten eine Gutschrift von {amount}." },
    "space-singular": { text: "space" },
    "space-plural": { text: "spaces" },

    // Subscription page translations
    "your-subscription-title": { text: "Ihr Abonnement" },
    "user-subscription-title": { text: "Benutzerabonnement" },
    "cancelled-on-text": { text: "Wird gekündigt am" },
    "renews-on-text": { text: "Verlängert am" },
    "current-plan-text": { text: "Aktueller Plan" },
    "manage-subscription-button": { text: "Abonnement verwalten" },
    "premium-spaces-title": { text: "Premium Spaces" },
    "premium-space-included-plan": { text: "Premium Space im Plan enthalten" },
    "additional-premium-space": { text: "Zusätzlicher Premium Space" },
    "manage-additional-spaces-button": { text: "Zusätzliche Premium Spaces verwalten" },
    "free-plan-text": { text: "Kostenloser Plan" },
    "free-text": { text: "Kostenlos" },
    "upgrade-plan-to-manage-spaces-button": { title: "Bitte aktualisieren Sie Ihren Plan, um Premium-Bereiche zu verwalten.", text: "Zusätzliche Premium Spaces verwalten" },
    "upgrade-plan-to-manage-spaces-text": { text: "Bitte aktualisieren Sie Ihren Plan, um Premium-Bereiche zu verwalten" },
    "account-credit-title": { text: "Kontoguthaben" },
    "available-credit-text": { text: "Verfügbares Guthaben für zukünftige Rechnungen" },
    "credit-text": { text: "Guthaben" },
    "balance-text": { text: "Saldo" },
    "show-plan-comparison": { text: "Zeigen Sie mir die Planvergleichsseite" },
    "no-active-subscription": { text: "Kein aktives Abonnement" },
    "subscribe-access-premium": { text: "Abonnieren Sie einen Plan, um auf Premium-Funktionen zuzugreifen" },
    "subscribe-now-button": { text: "Jetzt abonnieren" },
    "invoices-title": { text: "Rechnungen" },
    "issue-date-header": { text: "Ausstellungsdatum" },
    "description-header": { text: "Beschreibung" },
    "price-header": { text: "Preis" },
    "status-header": { text: "Status" },
    "no-payment-info": { text: "Keine Zahlungsinformationen" },
    "error-invite-to-tour-text": { text: "Nur Leiter können Leute zu Touren einladen" },
    "user-in-tour-error-text": { text: "Benutzer ist bereits in einer Tour" },
    "private-tour-text": { text: "Private Tour" },
    "private-tour-upgrade-text": { text: "Upgrade" },
    "you-must-be-invited-to-join-private-tour": { text: "Sie müssen eingeladen werden, um einer privaten Tour beizutreten" },

    "plan-update-upgrade-confirmation-title": { text: "Upgrade-Bestätigung" },
    "plan-update-downgrade-confirmation-title": { text: "Downgrade-Bestätigung" },
    "plan-update-items-text": { text: "Artikel" },
    "plan-update-period-text": { text: "Zeitraum" },
    "plan-update-qty-text": { text: "Menge" },
    "plan-update-amount-text": { text: "Betrag" },
    "plan-update-trial-period-text": { text: "Testzeitraum für" },
    "plan-update-estimation-note": { text: "Dies ist ein geschätzter Betrag. Die endgültige Gebühr kann aufgrund der Anteilsberechnung und Rundungsregeln von Stripe um einige Cent variieren." },
    "plan-update-payment-note": { text: " Nach Ihrer Bestätigung wird Stripe diesen Betrag sofort von Ihrer gespeicherten Zahlungsmethode abbuchen." },
    "plan-update-credit-note": { text: " Nach Ihrer Bestätigung wird keine Zahlung belastet. Verbleibendes Guthaben wird Ihrem Konto gutgeschrieben und auf zukünftige Rechnungen angewendet." },
    "plan-update-confirm-upgrade-text": { text: "Upgrade bestätigen" },
    "plan-update-confirm-downgrade-text": { text: "Downgrade bestätigen" },
    "plan-update-new-plan-text": { text: "Neuer Plan" },
    "plan-update-unused-time-text": { text: "Ungenutzte Zeit für" },
    "plan-update-after-text": { text: "nach" },
    "plan-update-applied-balance-text": { text: "Angewendetes Guthaben" },
    "plan-update-estimated-total-due-text": { text: "Geschätzter fälliger Betrag" },
    "plan-update-estimated-credit-text": { text: "Geschätztes Guthaben auf Kontostand angewendet" },
    "space-author-label": { text: "Autor:" },
    "space-info-text": { text: "Raum-Info" },
    "invited-text": { text: "(Eingeladen)" },
    "guided-tours": { text: "Geführte Touren" },
    "guided-tours-running": { text: "Es laufen geführte Touren ({count})" },
    "click-to-join": { text: "Zum Beitreten klicken" },
    "advertisement-links-text": { text: "Advertisment - contains affiliate links" },
    "unlimited-text": { text: "Unbegrenzt" },
    "editor-text": { text: "Editor" },
    "error-you-cannot-add-yourself-as-owner": { text: "Sie können sich nicht als Besitzer hinzufügen" },
    "you-are-already-contributor": { text: "Sie sind bereits ein Mitwirkender" },
    "tour-invitation-sent-text": { text: "Tour-Einladung gesendet" },
    "confirm-delete-postit": { text: "Bist Du sicher, dass Du diesen Postit löschen möchtest?" },
    "add-postit": { text: "Post-it hinzufügen" },
    "postit-created": { text: "Postit erfolgreich erstellt" },
    "postit-deleted": { text: "Postit erfolgreich gelöscht" },
    "not-allowed-to-create-postit": { text: "Sie sind nicht berechtigt, Postits zu erstellen" },
    "error-404-title": { text: "Seite nicht gefunden" },
    "error-404-alt": { alt: "Seite nicht gefunden" },
    "error-404-text": { text: "Hoppla! Die Seite, die Sie suchen, existiert nicht." },
    "error-403-title": { text: "Zugriff verweigert" },
    "error-403-alt": { alt: "Zugriff verweigert" },
    "error-403-text": { text: "Entschuldigung, Sie sind nicht berechtigt, auf diese Seite zuzugreifen." },
    "go-to-space-browser-text": { text: "Bring mich zum Space-Browser" },
    "only-creator-can-update-postit": { text: "Nur der Ersteller kann diesen Postit aktualisieren" },
    "error-cannot-jump-to-your-own-scene": { text: "Sie sind im selben Raum wie der Benutzer" },
    "chess-game-invitation-sent-text": { text: "Schachspiel-Einladung gesendet" },
    "user-in-activity-error-text": { text: "Benutzer ist bereits in einer Aktivität" },
    "invite-to-chess-game-text": { text: "Schachspiel-Einladung senden" },
    "error-requested-user-action": { text: "Benutzer nicht berechtigt, diese Aktion auszuführen" },
    "invite-text": { text: "Einladen" },
    "switch-sides-or-invite": { text: "Seiten wechseln oder einladen?" },
    "take-seat-as-player-white": { text: "Sitz als Spieler (Weiß)?" },
    "take-seat-as-player-black": { text: "Sitz als Spieler (Schwarz)?" },
    "switch-sides-text": { text: "Seiten wechseln" },
    "is-inviting-you-to-join-chess": { text: "lädt Sie ein, an das Schachspiel teilzunehmen" },
    "leave-game-and-take-seat-as-visitor-or-invite": { text: "Spiel verlassen und als Besucher sitzen oder einladen?" },
    "user-in-activity-error-text-message": { text: "Benutzer ist bereits in einer Aktivität, als Nachricht senden?" },
    "send-as-message-text": { text: "Als Nachricht senden" },
    "edit-video-player-element-text": { text: 'Video-Player-Element bearbeiten' },
    "upload-thumbnail-image-text": { text: 'Miniaturbild hochladen' },
    "video-player-image-text": { text: 'Video-Player-Bild' },
    "video-title-text": { text: 'Videotitel' },
    "add-video-player-text": { text: 'Video-Player hinzufügen' },
    "add-video-background-text": { text: 'Video-Hintergrund hinzufügen' },
    "edit-video-background-text": { text: 'Video-Hintergrund bearbeiten' },
    "add-vr-invisible-action": { text: "VR Unsichtbare Aktion hinzufügen" },
    "vr-invisible-action": { text: "VR Unsichtbare Aktion" },
    "edit-vr-invisible-action": { text: "VR Unsichtbare Aktion bearbeiten" },
    "add-vr-music-object": { text: "VR Musikobjekt hinzufügen" },
    "vr-music-object": { text: "VR Musikobjekt" },
    "edit-vr-music-object": { text: "VR Musikobjekt bearbeiten" },
    "action-play-once": { text: "Einmal abspielen" },
    "action-play-loop": { text: "In Schleife abspielen" },
    "action-stop-playing": { text: "Wiedergabe stoppen" },
    "event-play-once": { text: "Einmal abspielen" },
    "event-play-loop": { text: "In Schleife abspielen" },
    "event-stopped-playing": { text: "Wiedergabe beendet" },
    "event-video-started-playing": { text: "Video-Wiedergabe gestartet" },
    "event-raycast-enter": { text: "Kamera/Raycast betritt" },
    "event-raycast-leave": { text: "Kamera/Raycast verlässt" },
    "mp3-audio-text": { text: "MP3-Audio" },
    "no-audio-uploaded-yet": { text: "Noch keine Audiodatei hochgeladen" },
    "enter-optional-title-placeholder": { placeholder: 'Optionalen Titel eingeben' },
    "video-file-text": { text: 'Videodatei' },
    "no-video-selected-text": { text: 'Keine Videodatei ausgewählt' },
    "dimensions-text": { text: 'Abmessungen' },
    "play-text": { text: 'Abspielen' },
    "use-icon-text": { text: 'Symbol verwenden' },
    "place-as-3d-element-text": { text: 'Als 3D-Element platzieren' },
    "play-on-click-text": { text: 'Bei Klick abspielen' },
    "video-3d-placeholder-info-text": { text: 'Laden Sie ein Platzhalterbild hoch, oder das erste Videobild wird verwendet, wenn keines hochgeladen wurde.' },
    "video-player-placeholder-image-text": { text: 'Platzhalterbild' },
    "video-transparent-background-text": { text: 'Transparenter Hintergrund' },
    "video-transparent-background-info-text": { text: 'Für WebM-Videos mit Alphakanal aktivieren, damit der Hintergrund auf dem 3D-Mesh transparent bleibt.' },
    "default-video-icon-text": { text: 'Standard-Videosymbol' },
    "default-link-icon-text": { text: 'Standard-Linksymbol' },
    "default-gallery-icon-text": { text: 'Standard-Galeriesymbol' },
    "gallery-preview-image-text": { text: 'Vorschaubild' },
    "next-image-duration-text": { text: 'Dauer bis zum nächsten Bild (Sekunden)' },
    "gallery-uploading-text": { text: 'Wird hochgeladen…' },
    "gallery-upload-failed": { text: 'Hochladen fehlgeschlagen.' },
    "gallery-upload-file-too-big": { text: 'Diese Datei ist zu groß.' },
    "gallery-upload-unsupported-file": { text: 'Dieser Dateityp wird nicht unterstützt. Verwenden Sie JPG, PNG oder WebP.' },
    "gallery-upload-dismiss-title": { text: 'Verwerfen' },
    "gallery-rotate-left-title": { title: 'Nach links drehen' },
    "gallery-rotate-right-title": { title: 'Nach rechts drehen' },
    "confirm-delete-gallery-image": { text: 'Möchten Sie dieses Bild wirklich löschen?' },
    "gallery-previous-image": { text: 'Vorheriges Bild' },
    "gallery-next-image": { text: 'Nächstes Bild' },
    "gallery-close": { text: 'Galerie schließen' },
    "gallery-image-loading-text": { text: 'Wird geladen…' },
    "gallery-at-least-one-image": { text: 'Zum Veröffentlichen ist mindestens ein Bild erforderlich.' },
    "action-show-image": { text: 'Bild anzeigen' },
    "action-open-modal": { text: 'Modal öffnen' },
    "action-show-gallery": { text: 'Galerie anzeigen' },
    "action-start-slideshow": { text: 'Diashow starten' },
    "action-next-image": { text: 'Nächstes Bild' },
    "action-previous-image": { text: 'Vorheriges Bild' },
    "action-close-gallery": { text: 'Galerie schließen' },
    "action-close-video": { text: 'Video schließen' },
    "action-close-element": { text: 'Element schließen' },
    "no-video-uploaded-yet": { text: 'Es wurde noch kein Video hochgeladen' },
    "error-screen-share-limited": { text: "Ihre Bildschirmfreigabe ist begrenzt auf" },
    "error-screen-share-upgrade-text": { text: "Upgrade, um unbegrenzten Zugriff und ohne Zeitlimits zu erhalten!" },
    "minutes": { text: "Minuten" },
    "error-not-logged-in": { text: "Nur eingeloggte Benutzer können diese Funktion nutzen" },
    "you-need-to-login-to-take-a-seat": { text: "Sie müssen sich anmelden, um einen Sitzplatz in FREIEN Räumen einzunehmen" },
    "you-need-to-login-to-run-guided-tours": { text: "Sie müssen sich anmelden, um geführte Touren auszuführen" },
    "you-need-to-login-to-create-postit": { text: "Sie müssen sich anmelden, um Postits zu erstellen" },
    "you-need-to-login-to-use-screen-share": { text: "Sie müssen sich anmelden, um Bildschirmfreigabe zu verwenden" },
    "info-waiting-for-screen-share": { text: "Warten auf Bildschirmfreigabe" },
    "info-waiting-for-screen-share-users": { text: "Warten auf Bildschirmfreigabe-Benutzer" },
    "info-screen-share-started-users": { text: "Bildschirmfreigabe für Benutzer gestartet" },
    "vapi-command-action-fallback": { text: 'Befehlsaktion' },
    "vapi-command-text-placeholder": { text: 'Text an VAPI senden' },
    "vrai-agent-vapi-prompt": { text: 'VAPI-Prompt' },
    "vrai-agent-vapi-prompt-help": { text: 'Wird als zusätzlicher Raumkontext für diesen Agenten hinzugefügt.' },
    "vrai-agent-vapi-prompt-placeholder": { text: 'z. B. Dieser Raum ist die Lobby. Begrüßen Sie Besucher und beantworten Sie Fragen zum Raum.' },
    "vrai-agent-talk-to-agent-aria": { text: 'Mit KI sprechen' },
    "test-agent-text": { text: 'Agent testen' },
    "test-agent-idle": { text: 'Klicken Sie auf Anruf starten, um mit diesem Agenten zu sprechen' },
    "test-agent-no-agent": { text: 'Fügen Sie zuerst einen KI-Agenten hinzu, um dieses Token zu testen.' },
    "test-agent-token-label": { text: 'Token' },
    "vrai-agent-transcription-preview-user-line": { text: 'Hallo, können Sie mir helfen?' },
    "vrai-agent-transcription-preview-agent-line": { text: 'Natürlich! Was möchten Sie wissen?' },
    "vrai-agent-talk-summary-report-brand": { text: 'myLINA - Integration smart gedacht' },
    "vrai-agent-talk-summary-report-version": { text: 'myLINA Version: MVP2' },
    "vrai-agent-talk-summary-scenario-label": { text: 'Dialog Szenario' },
    "vrai-agent-talk-summary-participant-label": { text: 'Proband' },
    "vrai-agent-talk-summary-transcript-title": { text: 'DIALOG VERLAUF' },
    "vrai-agent-talk-summary-role-user": { text: '[PROBAND]: ' },
    "vrai-agent-talk-summary-role-agent": { text: '[PATIENT ] : ' },
    "drag-text": { text: 'Ziehen' },
    "remove-text": { text: 'Entfernen' },
    "vapi-not-initialized": { text: 'VAPI wurde nicht initialisiert. Bitte prüfen Sie Ihre Konfiguration.' },
    "vapi-set-public-key-help": { text: 'Ein privater API-Schlüssel ist erforderlich. Anrufe nutzen die schnelle Verbindung.' },
    "vapi-set-public-key-help-multi": { text: 'Ein privater API-Schlüssel ist erforderlich. Anrufe nutzen die schnelle Verbindung.' },
    "vapi-camera-mic-required": { text: 'Kamera- und Mikrofonzugriff ist für den Anruf erforderlich.' },
    "vapi-error-prefix": { text: 'Vapi-Fehler' },
    "vapi-error-check-config": { text: 'Bitte prüfen Sie die Konsole und die Assistant ID.' },
};
